export const openIntercom = (horizontal, vertical) => {
    if (horizontal) {
        window.intercomSettings.horizontal_padding = horizontal;
    }

    if (vertical) {
        window.intercomSettings.vertical_padding = vertical;
    }

    if(window.Intercom) {
        window.Intercom('update', window.intercomSettings);
    }
};

export const startSurveyIntercom = () => {
    const search = window.location.search.replace(/\?/, '');
    const params = new URLSearchParams(search);
    if (window.Intercom && params.has('intercom_survey_id')) {
        window.Intercom('startSurvey', params.get('intercom_survey_id'));
    }
};

export const destroyIntercom = () => {
    if(window.Intercom) {
        window.Intercom('shutdown');
    }
};



// WEBPACK FOOTER //
// ./src/helpers/intercom.helper.js